/**
 * OrderFileList Component
 */

import * as playerActions from '../../../../redux/actions/player';
import { getPlayerTracksFromResults } from '../../../../redux/helpers/player';
import { capitalizeString } from '../../../../utils/string';
import {
  getResponsiveTrackThumbnail,
  getTrackAssets,
  getTrackResultsFromLineItems,
} from '../../../../utils/track';
import './styles.scss';

import { map } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect, DispatchProp } from 'react-redux';

import Button from '../../../atoms/buttons/Button';
import { IconDownload, IconPlayerPause, IconPlayerPlay } from '../../../atoms/images/Icon';
import Thumbnail from '../../../atoms/images/Thumbnail';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';

interface IOwnStateProps {
  currentFilePlaying: string | null;
}

interface IOwnDispatchProps extends Required<DispatchProp<any>> {
  pausePlayer: () => void;
  playTrackVersion: (versionId: string) => void;
  setPlayerQueue: (tracks?: IPlayerTrack[]) => void;
}

interface IOwnProps {
  data: GQL.IOrder;
}

type OrderFileListProps = IOwnProps & IOwnStateProps & IOwnDispatchProps;

const classes = new BEM('file-list');
const defaultList = [];

class OrderFileList extends React.Component<OrderFileListProps, any> {

  componentDidMount() {
    this.props.dispatch(playerActions.toggleShouldOnlyPlayOriginalTracks(false));
    this.props.setPlayerQueue();
  }

  componentWillUnmount() {
    this.props.dispatch(playerActions.toggleShouldOnlyPlayOriginalTracks(true));
  }

  render() {
    const {
      currentFilePlaying,
      data,
      pausePlayer,
      playTrackVersion,
    } = this.props;
    const tracks = data.license_line_items!.map(({ track }) => track!);
    return (
      <div {...classes()}>
        <ul {...classes('list')}>
          {tracks.map((track) => {
            const audioAssets = getTrackAssets({
              assets: track.assets || defaultList,
              type: 'track-preview',
            }).concat(getTrackAssets({
              assets: track.assets || defaultList,
              type: 'track',
              format: 'wav',
            }));
            const accumulator: { [version: string]: GQL.IAsset[]; } = {};
            const versions = audioAssets.reduce((acc, asset) => {
              if (Object.keys(acc).indexOf(asset.version!) === -1) {
                acc[asset.version!] = [];
              }
              acc[asset.version!].push(asset);
              return acc;
            }, accumulator);

            const thumbnail = getResponsiveTrackThumbnail(track);

            return (<li key={track.id} {...classes('list__item')}>
              <div {...classes('track-info')}>
                <Thumbnail responsiveAssets={thumbnail} size="medium" />
                <Heading is="h4" {...classes('track-info__title')}>{track.title}</Heading>
                <Span size="small" textColor="bw7">{track.artist!.name}</Span>
              </div>
              <ul {...classes('version-list')}>
                {map(versions, (versionAssets, key) => (
                  <li key={key} {...classes('version-list__item')}>
                    <Heading is="h5" {...classes('version-list__title')}>{capitalizeString(key)} Version</Heading>
                    <ul {...classes('format-list')}>
                      {versionAssets.map(({ file_format, path, id, version }) => {
                        const PlayButton = currentFilePlaying === id ? IconPlayerPause : IconPlayerPlay;
                        return (
                          <li key={id} {...classes('format-list__item')}>
                            <Button
                              onClick={() => currentFilePlaying === id ? pausePlayer() : playTrackVersion(id)}
                              label={`${file_format!.toUpperCase()} file`}
                              icon={<PlayButton />}
                              size="xsmall"
                              {...classes('format-list__item__play-button') }
                            />
                            <Button
                              hyperLinkProps={{
                                href: `/${path}?download&invoice_number=${data.invoice_number}`,
                              }}
                              wrapperComponent="a"
                              label="Download"
                              icon={<IconDownload />}
                              size="small"
                              {...classes('format-list__item__download-button') }
                            />
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </li>);
          })}
        </ul>
        <Button
          hyperLinkProps={{
            href: `/orders/${data.invoice_number}/download`,
          }}
          label="Download All"
          variant="pill"
          colorScheme="accent"
          size="large"
          icon={<IconDownload />}
          withShadow
          wrapperComponent="a"
          {...classes('button-download-all')}
        />
      </div>
    );
  }
}

const ConnectedOrderFileList = connect<IOwnStateProps, IOwnDispatchProps, IOwnProps, OrderFileListProps, IStoreState>(
  ({ player: { currentTrack, isTrackPlaying } }) => ({
    currentFilePlaying: !!currentTrack && isTrackPlaying ? currentTrack.versionId : null,
  }),
  (dispatch) => ({
    dispatch,
    setPlayerQueue: (tracks) => {
      dispatch(playerActions.replaceQueue({ tracks: tracks! }));
    },
    pausePlayer: () => {
      dispatch(playerActions.pause());
    },
    playTrackVersion: (trackId) => {
      dispatch(playerActions.playTrackFromQueue({ trackId }));
    },
  }),
  (stateProps, { setPlayerQueue, ...dispatchProps }, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    setPlayerQueue: () => {
      setPlayerQueue(
        getPlayerTracksFromResults(
          getTrackResultsFromLineItems(
            ownProps.data.license_line_items!,
          ),
          false,
        ),
      );
    },
  }),
)(OrderFileList);
export default ConnectedOrderFileList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/account/OrderFileList/index.tsx